module.exports = __webpack_public_path__ + "img/keuze.3a793db5.svg";